import { CatalogData } from "ecom-types";

export interface CardProduct {
  images: CatalogData["images"];
  // title: ProductData["title"];
  id: CatalogData["id"];
  slug: CatalogData["slug"];
  base_cost: CatalogData["base_cost"];
  sale: CatalogData["sale"];
  sale_value: CatalogData["sale_value"];
  vendor_model: CatalogData["vendor_model"];
  badges: CatalogData["badges"];
  default_sku: CatalogData["default_sku"];
  embeded: CatalogData["embedded"];
  materials: CatalogData["materials"];
  material_categories: CatalogData["material_categories"];
  material_categories_plp_hover_ids: CatalogData["material_categories_plp_hover_ids"];
  default_config?: {
    materials?: any[];
  } | null;

  translations?: CatalogData["translations"];
}

export const useRecentReview = () => {
  const generalStore = useGeneralStore();
  const i18n = useI18n();
  // const recentlyViewed = useStorage<CardProduct[]>("recentlyViewed", []);
  // const recentlyViewedStorage = useStorage<CardProduct[]>("recentlyViewed", []);

  const currentTranslationId =
    generalStore.getCurrentLanguage(i18n.locale.value as string)?.id ||
    generalStore.getDefaultLanguage?.id;

  const recentlyViewed = computed(() => {
    return addCurrentTranslation(
      generalStore.recentlyViewedStorage,
      currentTranslationId as number,
      generalStore.getDefaultLanguage?.id as number,
    ) as CatalogData[];
  });
  function setRecentlyViewed(productData: CatalogData) {
    const maxItems = 10;
    const payload = productData;
    // const payload: CardProduct = {
    //   images: productData?.images,
    //   // title: productData?.title,
    //   id: productData?.id,
    //   slug: productData?.slug,
    //   base_cost: productData?.base_cost || 0,
    //   sale: productData.sale || false,
    //   sale_value: productData.sale_value,
    //   vendor_model: productData.vendor_model,
    //   badges: productData.badges,
    //   default_sku: productData.default_sku,
    //   embeded: productData.embedded,
    //   materials: productData.materials,
    //   material_categories: productData.material_categories,
    //   material_categories_plp_hover_ids:
    //     productData.material_categories_plp_hover_ids,
    //   default_config: productData.default_config,
    //   translations: productData.translations,
    // };

    const items = JSON.parse(
      JSON.stringify(generalStore.recentlyViewedStorage),
    );

    const existedProduct = items.find((el) => el.slug === payload?.slug);

    if (!existedProduct) {
      if (items.length >= maxItems) {
        items.pop();
      }
      items.unshift(payload);

      generalStore.recentlyViewedStorage = items;
    } else if (existedProduct) {
      // const replacedItemIdx = items.findIndex(
      //   (el) =>
      //     payload.id === el.id &&
      //     el.variant_plp_image?.sku !== payload.variant_plp_image?.sku
      // ); // always replace existed item
      const replacedItemIdx = items.findIndex((el) => payload.id === el.id);

      if (replacedItemIdx >= 0) {
        // items.splice(replacedItemIdx, 1, payload);
        items.splice(replacedItemIdx, 1);
        items.unshift(payload);

        generalStore.recentlyViewedStorage = items;
      }
    }

    // if (!isEmpty(items)) {
    //   if (
    //     items[0].slug === payload.slug &&
    //     items[0].default_sku !== payload.default_sku
    //   ) {
    //     items[0] = payload;
    //     localStorage.setItem("recentlyViewed", JSON.stringify(items));
    //   }
    // }
  }

  function updateRecentliView(data: CatalogData[]) {
    generalStore.recentlyViewedStorage = data;
  }

  return { setRecentlyViewed, updateRecentliView, recentlyViewed };
};
